export default __webpack_public_path__ + "static/media/water_bowser.002e2949.jpg";